export const languages = [
  { value: 'af-ZA', label: 'Afrikaans (South Africa)' },     
  { value: 'am-ET', label: 'Amharic (Ethiopia)' },
  { value: 'ar-AE', label: 'Arabic (United Arab Emirates)' },
  { value: 'ar-BH', label: 'Arabic (Bahrain)' },
  { value: 'ar-DZ', label: 'Arabic (Algeria)' },
  { value: 'ar-EG', label: 'Arabic (Egypt)' },
  { value: 'ar-IL', label: 'Arabic (Israel)' },
  { value: 'ar-IQ', label: 'Arabic (Iraq)' },
  { value: 'ar-JO', label: 'Arabic (Jordan)' },
  { value: 'ar-KW', label: 'Arabic (Kuwait)' },
  { value: 'ar-LB', label: 'Arabic (Lebanon)' },
  { value: 'ar-LY', label: 'Arabic (Libya)' },
  { value: 'ar-MA', label: 'Arabic (Morocco)' },
  { value: 'ar-OM', label: 'Arabic (Oman)' },
  { value: 'ar-PS', label: 'Arabic (Palestinian Authority)' },
  { value: 'ar-QA', label: 'Arabic (Qatar)' },
  { value: 'ar-SA', label: 'Arabic (Saudi Arabia)' },
  { value: 'ar-SY', label: 'Arabic (Syria)' },
  { value: 'ar-TN', label: 'Arabic (Tunisia)' },
  { value: 'ar-YE', label: 'Arabic (Yemen)' },
  { value: 'az-AZ', label: 'Azerbaijani (Latin, Azerbaijan)' },
  { value: 'bg-BG', label: 'Bulgarian (Bulgaria)' },
  { value: 'bn-IN', label: 'Bengali (India)' },
  { value: 'bs-BA', label: 'Bosnian (Bosnia and Herzegovina)' },
  { value: 'ca-ES', label: 'Catalan' },
  { value: 'cs-CZ', label: 'Czech (Czechia)' },
  { value: 'cy-GB', label: 'Welsh (United Kingdom)' },
  { value: 'da-DK', label: 'Danish (Denmark)' },
  { value: 'de-AT', label: 'German (Austria)' },
  { value: 'de-CH', label: 'German (Switzerland)' },
  { value: 'de-DE', label: 'German (Germany)' },
  { value: 'el-GR', label: 'Greek (Greece)' },
  { value: 'en-AU', label: 'English (Australia)' },
  { value: 'en-CA', label: 'English (Canada)' },
  { value: 'en-GB', label: 'English (United Kingdom)' },
  { value: 'en-GH', label: 'English (Ghana)' },
  { value: 'en-HK', label: 'English (Hong Kong SAR)' },
  { value: 'en-IE', label: 'English (Ireland)' },
  { value: 'en-IN', label: 'English (India)' },
  { value: 'en-KE', label: 'English (Kenya)' },
  { value: 'en-NG', label: 'English (Nigeria)' },
  { value: 'en-NZ', label: 'English (New Zealand)' },
  { value: 'en-PH', label: 'English (Philippines)' },
  { value: 'en-SG', label: 'English (Singapore)' },
  { value: 'en-TZ', label: 'English (Tanzania)' },
  { value: 'en-US', label: 'English (United States)' },
  { value: 'en-ZA', label: 'English (South Africa)' },
  { value: 'es-AR', label: 'Spanish (Argentina)' },
  { value: 'es-BO', label: 'Spanish (Bolivia)' },
  { value: 'es-CL', label: 'Spanish (Chile)' },
  { value: 'es-CO', label: 'Spanish (Colombia)' },
  { value: 'es-CR', label: 'Spanish (Costa Rica)' },
  { value: 'es-CU', label: 'Spanish (Cuba)' },
  { value: 'es-DO', label: 'Spanish (Dominican Republic)' },
  { value: 'es-EC', label: 'Spanish (Ecuador)' },
  { value: 'es-ES', label: 'Spanish (Spain)' },
  { value: 'es-GQ', label: 'Spanish (Equatorial Guinea)' },
  { value: 'es-GT', label: 'Spanish (Guatemala)' },
  { value: 'es-HN', label: 'Spanish (Honduras)' },
  { value: 'es-MX', label: 'Spanish (Mexico)' },
  { value: 'es-NI', label: 'Spanish (Nicaragua)' },
  { value: 'es-PA', label: 'Spanish (Panama)' },
  { value: 'es-PE', label: 'Spanish (Peru)' },
  { value: 'es-PR', label: 'Spanish (Puerto Rico)' },
  { value: 'es-PY', label: 'Spanish (Paraguay)' },
  { value: 'es-SV', label: 'Spanish (El Salvador)' },
  { value: 'es-US', label: 'Spanish (United States)' },
  { value: 'es-UY', label: 'Spanish (Uruguay)' },
  { value: 'es-VE', label: 'Spanish (Venezuela)' },
  { value: 'et-EE', label: 'Estonian (Estonia)' },
  { value: 'eu-ES', label: 'Basque' },
  { value: 'fa-IR', label: 'Persian (Iran)' },
  { value: 'fi-FI', label: 'Finnish (Finland)' },
  { value: 'fil-PH', label: 'Filipino (Philippines)' },
  { value: 'fr-BE', label: 'French (Belgium)' },
  { value: 'fr-CA', label: 'French (Canada)' },
  { value: 'is-IS', label: 'Icelandic (Iceland)' },
  { value: 'it-CH', label: 'Italian (Switzerland)' },
  { value: 'it-IT', label: 'Italian (Italy)' },
  { value: 'ja-JP', label: 'Japanese (Japan)' },
  { value: 'jv-ID', label: 'Javanese (Latin, Indonesia)' },
  { value: 'ka-GE', label: 'Georgian (Georgia)' },
  { value: 'kk-KZ', label: 'Kazakh (Kazakhstan)' },
  { value: 'km-KH', label: 'Khmer (Cambodia)' },
  { value: 'kn-IN', label: 'Kannada (India)' },
  { value: 'ko-KR', label: 'Korean (Korea)' },
  { value: 'lo-LA', label: 'Lao (Laos)' },
  { value: 'lt-LT', label: 'Lithuanian (Lithuania)' },
  { value: 'lv-LV', label: 'Latvian (Latvia)' },
  { value: 'mk-MK', label: 'Macedonian (North Macedonia)' },
  { value: 'ml-IN', label: 'Malayalam (India)' },
  { value: 'mn-MN', label: 'Mongolian (Mongolia)' },        
  { value: 'mr-IN', label: 'Marathi (India)' },
  { value: 'ms-MY', label: 'Malay (Malaysia)' },
  { value: 'mt-MT', label: 'Maltese (Malta)' },
  { value: 'my-MM', label: 'Burmese (Myanmar)' },
  { value: 'nb-NO', label: 'Norwegian Bokmål (Norway)' },   
  { value: 'ne-NP', label: 'Nepali (Nepal)' },
  { value: 'nl-BE', label: 'Dutch (Belgium)' },
  { value: 'nl-NL', label: 'Dutch (Netherlands)' },
  { value: 'pa-IN', label: 'Punjabi (India)' },
  { value: 'pl-PL', label: 'Polish (Poland)' },
  { value: 'ps-AF', label: 'Pashto (Afghanistan)' },        
  { value: 'pt-BR', label: 'Portuguese (Brazil)' },
  { value: 'pt-PT', label: 'Portuguese (Portugal)' },
  { value: 'ro-RO', label: 'Romanian (Romania)' },
  { value: 'ru-RU', label: 'Russian (Russia)' },
  { value: 'si-LK', label: 'Sinhala (Sri Lanka)' },
  { value: 'sk-SK', label: 'Slovak (Slovakia)' },
  { value: 'sl-SI', label: 'Slovenian (Slovenia)' },
  { value: 'so-SO', label: 'Somali (Somalia)' },
  { value: 'sq-AL', label: 'Albanian (Albania)' },
  { value: 'sr-RS', label: 'Serbian (Cyrillic, Serbia)' },
  { value: 'sv-SE', label: 'Swedish (Sweden)' },
  { value: 'sw-KE', label: 'Kiswahili (Kenya)' },
  { value: 'sw-TZ', label: 'Kiswahili (Tanzania)' },
  { value: 'ta-IN', label: 'Tamil (India)' },
  { value: 'te-IN', label: 'Telugu (India)' },
  { value: 'th-TH', label: 'Thai (Thailand)' },
  { value: 'tr-TR', label: 'Turkish (Türkiye)' },
  { value: 'uk-UA', label: 'Ukrainian (Ukraine)' },
  { value: 'ur-IN', label: 'Urdu (India)' },
  { value: 'uz-UZ', label: 'Uzbek (Latin, Uzbekistan)' },
  { value: 'vi-VN', label: 'Vietnamese (Vietnam)' },
  { value: 'wuu-CN', label: 'Chinese (Wu, Simplified)' },
  { value: 'yue-CN', label: 'Chinese (Cantonese, Simplified)' },
  { value: 'zh-CN', label: 'Chinese (Mandarin, Simplified)' },
  { value: 'zh-CN-shandong', label: 'Chinese (Jilu Mandarin, Simplified)'},
  { value: 'zh-CN-sichuan', label: 'Chinese (Southwestern Mandarin, Simplified)'},
  { value: 'zh-HK', label: 'Chinese (Cantonese, Traditional)' },
  { value: 'zh-TW', label: 'Chinese (Taiwanese Mandarin, Traditional)'},
  { value: 'zu-ZA', label: 'isiZulu (South Africa)' }
]

export const spellingFormats = [
    "US English", 
    "UK English", 
    "Canadian English", 
    "Australian English"
];

export const noteGenerationLanguages = [
    "English",
    "Chinese (Mandarin, Simplified)",
    "Chinese (Cantonese, Traditional)",
]

export const transcriptionLanguages = [
  { value: 'afr', label: 'Afrikaans' },
  { value: 'amh', label: 'Amharic' },
  { value: 'ara', label: 'Arabic' },
  { value: 'hye', label: 'Armenian' },
  { value: 'asm', label: 'Assamese' },
  { value: 'ast', label: 'Asturian' },
  { value: 'aze', label: 'Azerbaijani' },
  { value: 'bel', label: 'Belarusian' },
  { value: 'ben', label: 'Bengali' },
  { value: 'bos', label: 'Bosnian' },
  { value: 'bul', label: 'Bulgarian' },
  { value: 'mya', label: 'Burmese' },
  { value: 'yue', label: 'Cantonese' },
  { value: 'cat', label: 'Catalan' },
  { value: 'ceb', label: 'Cebuano' },
  { value: 'nya', label: 'Chichewa' },
  { value: 'hrv', label: 'Croatian' },
  { value: 'ces', label: 'Czech' },
  { value: 'dan', label: 'Danish' },
  { value: 'nld', label: 'Dutch' },
  { value: 'eng', label: 'English' },
  { value: 'est', label: 'Estonian' },
  { value: 'fil', label: 'Filipino' },
  { value: 'fin', label: 'Finnish' },
  { value: 'fra', label: 'French' },
  { value: 'ful', label: 'Fulah' },
  { value: 'glg', label: 'Galician' },
  { value: 'lug', label: 'Ganda' },
  { value: 'kat', label: 'Georgian' },
  { value: 'deu', label: 'German' },
  { value: 'ell', label: 'Greek' },
  { value: 'guj', label: 'Gujarati' },
  { value: 'hau', label: 'Hausa' },
  { value: 'heb', label: 'Hebrew' },
  { value: 'hin', label: 'Hindi' },
  { value: 'hun', label: 'Hungarian' },
  { value: 'isl', label: 'Icelandic' },
  { value: 'ibo', label: 'Igbo' },
  { value: 'ind', label: 'Indonesian' },
  { value: 'gle', label: 'Irish' },
  { value: 'ita', label: 'Italian' },
  { value: 'jpn', label: 'Japanese' },
  { value: 'jav', label: 'Javanese' },
  { value: 'kea', label: 'Kabuverdianu' },
  { value: 'kan', label: 'Kannada' },
  { value: 'kaz', label: 'Kazakh' },
  { value: 'khm', label: 'Khmer' },
  { value: 'kor', label: 'Korean' },
  { value: 'kur', label: 'Kurdish' },
  { value: 'kir', label: 'Kyrgyz' },
  { value: 'lao', label: 'Lao' },
  { value: 'lav', label: 'Latvian' },
  { value: 'lin', label: 'Lingala' },
  { value: 'lit', label: 'Lithuanian' },
  { value: 'luo', label: 'Luo' },
  { value: 'ltz', label: 'Luxembourgish' },
  { value: 'mkd', label: 'Macedonian' },
  { value: 'msa', label: 'Malay' },
  { value: 'mal', label: 'Malayalam' },
  { value: 'mlt', label: 'Maltese' },
  { value: 'zho', label: 'Mandarin Chinese' },
  { value: 'mri', label: 'Māori' },
  { value: 'mar', label: 'Marathi' },
  { value: 'mon', label: 'Mongolian' },
  { value: 'nep', label: 'Nepali' },
  { value: 'nso', label: 'Northern Sotho' },
  { value: 'nor', label: 'Norwegian' },
  { value: 'oci', label: 'Occitan' },
  { value: 'ori', label: 'Odia' },
  { value: 'pus', label: 'Pashto' },
  { value: 'fas', label: 'Persian' },
  { value: 'pol', label: 'Polish' },
  { value: 'por', label: 'Portuguese' },
  { value: 'pan', label: 'Punjabi' },
  { value: 'ron', label: 'Romanian' },
  { value: 'rus', label: 'Russian' },
  { value: 'srp', label: 'Serbian' },
  { value: 'sna', label: 'Shona' },
  { value: 'snd', label: 'Sindhi' },
  { value: 'slk', label: 'Slovak' },
  { value: 'slv', label: 'Slovenian' },
  { value: 'som', label: 'Somali' },
  { value: 'spa', label: 'Spanish' },
  { value: 'swa', label: 'Swahili' },
  { value: 'swe', label: 'Swedish' },
  { value: 'tam', label: 'Tamil' },
  { value: 'tgk', label: 'Tajik' },
  { value: 'tel', label: 'Telugu' },
  { value: 'tha', label: 'Thai' },
  { value: 'tur', label: 'Turkish' },
  { value: 'ukr', label: 'Ukrainian' },
  { value: 'umb', label: 'Umbundu' },
  { value: 'urd', label: 'Urdu' },
  { value: 'uzb', label: 'Uzbek' },
  { value: 'vie', label: 'Vietnamese' },
  { value: 'cym', label: 'Welsh' },
  { value: 'wol', label: 'Wolof' },
  { value: 'xho', label: 'Xhosa' },
  { value: 'zul', label: 'Zulu' }
];